/**
 * A table row that leads somewhere, for a pointer: a click anywhere on the row
 * follows it, unless the click started on something interactive inside the
 * row — a checkbox, a button, the row's own link — or the reader was selecting
 * text. The row itself gets no role and no tabindex: keyboard and screen-reader
 * users reach the same place through the real link in the row, and a row
 * pretending to be a button would hide the table semantics from them.
 */
const INTERACTIVE = 'a, button, input, select, textarea, label, summary, [role="button"], [contenteditable="true"]';

/**
 * @param {MouseEvent} event - the click on the row
 * @param {() => void} go - what following the row means
 */
export function rowClick(event, go) {
  if (event.defaultPrevented || event.button !== 0) return;
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
  if (event.target?.closest?.(INTERACTIVE)) return;
  if (typeof window !== 'undefined' && window.getSelection?.()?.toString()) return;
  go();
}
